<template>
  <div class="wrapper">
    <el-carousel id="homeCarousel" class="no-border no-height" trigger="click" :interval="5000">
      <el-carousel-item>
        <div class="page-header header-filter" :style="header('1')">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-66 md-small-size-100 text-left">
                <h1 class="title">Your Local Sand & Gravel Supplier</h1>
                <!-- <h4>
                  Tristique nulla aliquet enim tortor at auctor urna nunc id cursus
                  metus aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices
                  sagittis orci a scelerisque purus semper eget duis at
                </h4> -->
                <br />
                <div class="buttons">
                  <md-button href="/#products" class="md-danger md-lg">View our products</md-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <!-- <el-carousel-item>
        <div class="page-header header-filter" :style="header('2')">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center">
                <h1 class="title">Maecenas pharetra convallis</h1>
                <h4>
                  Et pharetra pharetra massa massa ultricies mi quis hendrerit
                  dolor magna eget est lorem ipsum dolor sit amet consectetur
                  adipiscing elit pellentesque habitant morbi tristique senectus
                  et netus et malesuada fames
                </h4>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item> -->
    </el-carousel>
    <div class="main">
      <div id="about" class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center">
              <h2 class="title text-center">Our Story</h2>
              <h5 class="description">
                Flag Resources Inc. DBA Flag Sand & Gravel is a family owned and operated
                Gravel pit since 1990. We strive for high quality products from sand and
                washed natural products to crushed aggregate and recycled asphalt.
                We strive to help our customers find the best solutions for
                landscaping and the best products for any gravel need.
                As a business we want to be there for our customers and employees
                offering friendly customer service and a safe and productive team
                focused work environment for our employees.
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div id="products" class="section section-projects-2 section-gray">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100
                justify-content-center mx-auto text-center margin-bottom-40">
              <h2 class="title">Our Products</h2>
              <h5 class="description">
              </h5>
              <md-button href="/products" class="md-warning">View all products</md-button>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100" v-for="product in products.slice(0, 3)"
              :key="product.id">
              <profile-card card-plain :shadow-normal="false" :no-colored-shadow="false"
                :image-link="`/product/${product.id}`" :card-image="imageForProduct(product)">
                <template slot="cardContent">
                  <router-link :to="`/product/${product.id}`">
                    <h4 class="card-title">{{ product.name }}</h4>
                  </router-link>
                  <p class="card-description">
                    {{ product.description }}
                  </p>
                </template>
              </profile-card>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" class="section-contactus-2">
        <div id="contactUs2Map" class="map"></div>
        <div class="row">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="md-card-contact">
              <md-card-header class="md-card-header-orange text-center">
                <h4 class="card-title">Contact Us</h4>
              </md-card-header>
              <form @submit.prevent="submitContactForm">
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <info-areas info-horizontal icon-color="success" icon="phone">
                        <h4 class="info-title" slot="title">Give us a ring</h4>
                        <div class="description" slot="content">
                          <p>
                            (970) 876-2397 <br />
                            Mon - Fri, 7:00 AM - 4:00 PM <br />
                          </p>
                        </div>
                      </info-areas>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <info-areas info-horizontal icon-color="success" icon="pin_drop">
                        <h4 class="info-title" slot="title">
                          Find us at the office
                        </h4>
                        <div class="description" slot="content">
                          <p>
                            Flag Sand & Gravel<br />
                            1412 Co Rd 311<br />
                            New Castle, CO 81647<br />
                          </p>
                        </div>
                      </info-areas>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <label>Full Name</label>
                        <md-input v-model="contactForm.name" name="name" v-validate="'required'">
                        </md-input>
                      </md-field>
                      <span class="error">{{ errors.first('name') }}</span>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <label>Email Address</label>
                        <md-input v-model="contactForm.email" name="email" v-validate="'required|email'" type="email">
                        </md-input>
                      </md-field>
                      <span class="error">{{ errors.first('email') }}</span>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Your Message</label>
                        <md-textarea v-model="contactForm.message" name="message" v-validate="'required'">
                        </md-textarea>
                      </md-field>
                      <span class="error">{{ errors.first('message') }}</span>
                    </div>
                  </div>
                  <div v-if="formErrorMessage" class="alert alert-danger">
                    <div class="container">
                      <div class="alert-icon">
                        <md-icon>info_outline</md-icon>
                      </div>
                      <strong>ERROR:</strong>{{ formErrorMessage }}
                    </div>
                  </div>
                  <div v-if="formSuccessMessage" class="alert alert-success">
                    <div class="container">
                      <div class="alert-icon">
                        <md-icon>check</md-icon>
                      </div>
                      <strong>SUCCESS: </strong>{{ formSuccessMessage }}
                    </div>
                  </div>
                </md-card-content>
                <md-card-actions class="d-flex justify-content-between">
                  <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="captchaSiteKey" @verify="onCaptchaVerified"
                    @expired="onCaptchaExpired">
                  </vue-recaptcha>
                  <md-button class="md-success" type="submit">Send Message</md-button>
                </md-card-actions>
              </form>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import Mixins from '@/plugins/basicMixins';

import { Query, Mutation } from '@/graphql';
import apollo from '@/services/apollo-graphql';
import { ProfileCard, InfoAreas } from '@/components';

const Image1 = require('@/assets/img/slider/slider1.png');

export default {
  name: 'Home',
  mixins: [Mixins.HeaderImage, Mixins.InitMap],
  components: { ProfileCard, InfoAreas, VueRecaptcha },
  bodyClass: 'landing-page',
  async created() {
    const response = await apollo.query({
      query: Query.getProducts,
    });
    this.products = response.data.products;
  },
  data() {
    return {
      formErrorMessage: null,
      formSuccessMessage: null,
      captchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      products: [],
      contactForm: {
        name: null,
        email: null,
        message: null,
      },
      headerImages: {
        Image1,
      },
    };
  },
  methods: {
    header(number) {
      return {
        backgroundImage: `url(${this.headerImages[`Image${number}`]})`,
      };
    },
    imageForProduct(product) {
      if (product.photos && product.photos.length) {
        return product.photos[0].url;
      }
      return require('@/assets/img/product-placeholder.png');
    },
    submitContactForm() {
      this.formErrorMessage = null;
      this.formSuccessMessage = null;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$refs.recaptcha.execute();
        }
      });
    },
    async onCaptchaVerified(recaptchaToken) {
      if (recaptchaToken) {
        this.$refs.recaptcha.reset();
        try {
          const response = await apollo.mutate({
            mutation: Mutation.addContactForm,
            variables: {
              name: this.contactForm.name,
              email: this.contactForm.email,
              message: this.contactForm.message,
              recaptcha: recaptchaToken,
            },
          });
          if (response.data.addContactForm) {
            this.formSuccessMessage = 'Thank you! We will be in touch soon.';
            this.resetForm();
          }
        } catch (error) {
          this.formErrorMessage = error;
        }
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    resetForm() {
      Object.keys(this.contactForm).forEach((key) => { this.contactForm[key] = null; });
      this.$validator.reset();
    },
  },
};
</script>

<style lang="scss">
.el-carousel__arrow,
.el-carousel__indicators {
  display: none !important; // remove this if wanting to use multiple images
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.section-projects-2 .description {
  margin-bottom: 20px !important;
}

.md-has-textarea+.md-layout {
  margin-top: 15px;
}

#homeCarousel .el-carousel__container {
  height: 100vh !important;
}

#homeCarousel.el-carousel {
  border-radius: unset;
}

.section-contactus-2 {
  height: 800px;
}

.thumb-list img {
  max-height: 150px;
  width: auto;
}
</style>
